import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"
import _imports_0 from '../assets/icons/icon.png'


const _hoisted_1 = { class: "flex min-h-full flex-1 flex-col justify-center pb-12 sm:px-6 lg:px-8" }
const _hoisted_2 = { class: "sm:mx-auto sm:w-full sm:max-w-md" }
const _hoisted_3 = { class: "mt-6 text-center text-2xl font-bold leading-9 tracking-tight text-gray-900" }
const _hoisted_4 = { class: "mt-8 sm:mx-auto sm:w-full sm:max-w-[480px]" }
const _hoisted_5 = { class: "py-16 sm:rounded-lg sm:px-12 rounded-xl bg-gray-800 bg-opacity-50 px-16 shadow-lg backdrop-blur-md max-sm:px-4 backdrop-filter-none" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("img", {
  class: "mx-auto h-14 w-auto -mt-24 z-10",
  src: _imports_0,
  alt: "MobiPoints"
}, null, -1)
const _hoisted_7 = { class: "relative mt-10" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", {
  class: "absolute inset-0 flex items-center",
  "aria-hidden": "true"
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "w-full border-t border-gray-200" })
], -1)
const _hoisted_9 = { class: "relative flex justify-center text-sm font-medium leading-6" }
const _hoisted_10 = { class: "bg-white px-6 text-gray-900 rounded-xl" }
const _hoisted_11 = { class: "mt-6" }
const _hoisted_12 = { class: "w-full items-center justify-center shadow rounded-md focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2" }
const _hoisted_13 = { class: "mt-7 text-center text-sm text-gray-800" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_15 = { style: {"margin":"auto","text-align":"center"} }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("a", {
  style: {"cursor":"pointer"},
  class: "ion-color-medium"
}, "Datenschutz", -1)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("span", { style: {"padding-left":"5px","padding-right":"5px"} }, "|", -1)
const _hoisted_18 = /*#__PURE__*/_createElementVNode("a", { style: {"cursor":"pointer"} }, "AGB", -1)
const _hoisted_19 = /*#__PURE__*/_createElementVNode("span", { style: {"padding-left":"5px","padding-right":"5px"} }, "|", -1)
const _hoisted_20 = /*#__PURE__*/_createElementVNode("a", { style: {"cursor":"pointer"} }, "Impressum", -1)
const _hoisted_21 = { style: {"margin":"auto","text-align":"center","padding-bottom":"15px","font-size":"7px"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_basic_login = _resolveComponent("basic-login")!
  const _component_google_login = _resolveComponent("google-login")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_mobility_logo = _resolveComponent("mobility-logo")!
  const _component_ion_footer = _resolveComponent("ion-footer")!
  const _component_ion_page = _resolveComponent("ion-page")!

  return (_openBlock(), _createBlock(_component_ion_page, { class: "bg-gradient-to-r from-teal-200 to-lime-200" }, {
    default: _withCtx(() => [
      _createVNode(_component_ion_content, { class: "ion-padding loginBackground" }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("h2", null, _toDisplayString($setup.loginTitle), 1),
                _createElementVNode("h3", null, _toDisplayString($setup.loginWithBasic), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _hoisted_6,
                _createVNode(_component_basic_login),
                _createElementVNode("div", null, [
                  _createElementVNode("div", _hoisted_7, [
                    _hoisted_8,
                    _createElementVNode("div", _hoisted_9, [
                      _createElementVNode("span", _hoisted_10, _toDisplayString($setup.orLoginWithGoogle), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_11, [
                    _createElementVNode("div", _hoisted_12, [
                      _createVNode(_component_google_login, { id: "google-login-component" })
                    ])
                  ]),
                  _createElementVNode("p", _hoisted_13, [
                    _createTextVNode(_toDisplayString($setup.noAccount) + " " + _toDisplayString(' ') + " ", 1),
                    _hoisted_14,
                    _createVNode(_component_router_link, {
                      to: "/register",
                      class: "font-semibold leading-6 text-green-50 hover:text-black w-full"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString($setup.registerHere), 1)
                      ]),
                      _: 1
                    })
                  ])
                ])
              ])
            ])
          ])
        ]),
        _: 1
      }),
      _createVNode(_component_ion_footer, { class: "ion-padding" }, {
        default: _withCtx(() => [
          _createElementVNode("p", _hoisted_15, [
            _createElementVNode("span", null, [
              _createVNode(_component_router_link, { to: "/privacy-crudafoch" }, {
                default: _withCtx(() => [
                  _hoisted_16
                ]),
                _: 1
              })
            ]),
            _hoisted_17,
            _createElementVNode("span", null, [
              _createVNode(_component_router_link, { to: "/terms" }, {
                default: _withCtx(() => [
                  _hoisted_18
                ]),
                _: 1
              })
            ]),
            _hoisted_19,
            _createElementVNode("span", null, [
              _createVNode(_component_router_link, { to: "/impress" }, {
                default: _withCtx(() => [
                  _hoisted_20
                ]),
                _: 1
              })
            ])
          ]),
          _createElementVNode("p", _hoisted_21, " Version: " + _toDisplayString($setup.appVersion), 1),
          _createVNode(_component_mobility_logo)
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}